import { observer } from 'mobx-react-lite';
import styled from 'styled-components';

import { useIsMobile } from '@hooks/use-is-mobile';

import { useSeasonalTheme } from 'features/seasonal-theme';

import christmas2021BackgroundImage from '../static/images/christmas2021-background.jpg';

export const SeasonalStyles = observer(() => {
  const seasonalTheme = useSeasonalTheme();
  const isMobile = useIsMobile();
  if (isMobile) return null;

  switch (seasonalTheme) {
    case 'christmas2021':
      return <Christmas2021 />;
    default:
      return null;
  }
});

const Christmas2021 = observer(() => {
  return (
    <Container
      style={{
        backgroundImage: `url(${christmas2021BackgroundImage})`,
        opacity: '0.25',
      }}
    />
  );
});

const Container = styled.div({
  position: 'fixed',
  transition: 'opacity 400ms ease-in-out',
  zIndex: 0,
  left: 72,
  top: 0,
  bottom: 0,
  right: 0,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  backgroundPosition: 'bottom',
});
